import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function ClosingCTA() {
  return <section id="cta-final" className="py-16 md:py-[100px] px-4 text-center" data-id="element-1">
      <div className="max-w-[800px] mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-3">
          <div className="mb-4 flex items-center justify-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-gold uppercase" data-id="element-4">
            <span className="inline-block h-[2px] w-5 bg-gold" data-id="element-5"></span>
            Última Llamada
            <span className="inline-block h-[2px] w-5 bg-gold" data-id="element-6"></span>
          </div>

          <h2 className="mb-6 font-heading text-3xl md:text-[40px] font-black leading-[1.1] text-white uppercase tracking-tight" data-id="element-7">
            TU ANTIGUA VIDA ESTÁ A UNA DECISIÓN DE{' '}
            <span className="text-gold" data-id="element-8">ROMPERSE</span>
          </h2>

          <p className="text-[15px] text-text-secondary mb-12 max-w-[600px] mx-auto leading-[1.8]" data-id="element-9">
            No permitas que tu viejo yo te convenza de "esperar a mañana".
            Mañana es el lugar donde mueren todos los sueños.{' '}
            <strong className="text-white" data-id="element-10">
              Actúa desde tu nueva identidad hoy.
            </strong>
          </p>

          <div className="flex justify-center mb-16" data-id="element-11">
            <CTAButton variant="purchase" data-id="element-12" />
          </div>

          <div className="w-full h-px bg-border mb-12" data-id="element-13" />

          <div className="rounded-lg border border-border bg-surface-dark px-[30px] py-[24px]" data-id="element-14">
            <p className="text-[15px] md:text-[17px] font-bold italic text-gold leading-[1.8]" data-id="element-15">
              "Porque cuando identificas tu punto ciego, no solo cambia tu
              vida... cambia la vida de tus hijos, de tus nietos y de tus
              futuras generaciones. Nos vemos adentro."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}